import React from 'react';
import styled, { css } from 'styled-components';
import { Trans } from 'react-i18next';
import { FlexColumn, FlexSpace, SmallBody, Header2 } from '@ubeya/shared-web/components';
import { media, responsiveRow } from '@ubeya/shared-web/style';

const textStyle = css`
  font-weight: 400;
  line-height: 24px;
`;

const Wrapper = styled(FlexSpace)`
  ${responsiveRow.mobile}
  align-items: flex-start;
  ${media.mobile`align-items: center;`}
`;

const Cell = styled(FlexColumn)`
  &:not(:last-child) {
    margin-top: 20px;
    ${media.mobile`margin-top: 0; margin-right: 20px;`}
  }
`;

const Title = styled(SmallBody)`
  ${textStyle}
  color: ${({ theme }) => theme.colors.disabled};
`;

const Value = styled(Header2)`
  ${textStyle}
  font-size: 14px;
  white-space: nowrap;
`;

const ViewCreditCard = ({
  creditCard: {
    payload: { expiry, digits }
  }
}) => {
  const type = 'mastercard';

  // eslint-disable-next-line
  const TypeIcon = require(`shared/assets/creditcards/${type}.svg`)?.ReactComponent;

  return (
    <Wrapper>
      <Cell>
        <Title>
          <Trans>cardNumber</Trans>
        </Title>
        <Value>**** **** **** {digits}</Value>
      </Cell>

      <Cell>
        <Title>
          <Trans>expiryDate</Trans>
        </Title>
        <Value>{expiry}</Value>
      </Cell>
    </Wrapper>
  );
};

export default ViewCreditCard;
